import { all, takeLatest, put, call, fork } from 'redux-saga/effects'
import { actions, constants } from './actions'
import { apiV2 } from '../../services/api'
import { formUtils } from './utils'
import getLookups from 'views/Config/lookups'

const { SUBMIT_FORM } = constants
const { submitForm } = actions
const { checkFields, formatPayload } = formUtils(getLookups())

// Action sagas - async
function * submitFormRequest () {
  yield takeLatest('SUBMIT_FORM/REQUEST', function * ({ payload }) {
    try {
      const successMessage = 'Call Report successfully submitted.'
      if (payload.originCallReportId === 0) { delete payload.originCallReportId }
      if (!payload.age) { delete payload.age }
      if (!payload.yearsOfMilitaryService) { delete payload.yearsOfMilitaryService }
      if (!payload.yearsOfPoliceService) { delete payload.yearsOfPoliceService }

      // check for required fields
      const callEntryType = payload.callEntryType.value
      const skipValidation = ['wrongNumber', 'nonLawEnforcement', 'noCaller'].includes(callEntryType)
      if (!skipValidation) {
        const { validationErrors } = checkFields(payload)
        if (validationErrors) {
          yield put(submitForm.failure({ source: SUBMIT_FORM, message: validationErrors }))
          return
        }
      }

      // Format payload (extracts values from dropdowns, converts headTrauma to array)
      const formattedPayload = formatPayload(payload)
      // Remove callTakerId since V2 backend extracts it from JWT
      const { callTakerId, ...v2Payload } = formattedPayload

      yield call(apiV2.callReports.create, v2Payload)
      yield put(submitForm.success({ source: SUBMIT_FORM, message: successMessage }))
    } catch (err) {
      yield put(submitForm.failure({ source: SUBMIT_FORM, message: 'Unable to submit call report, please try again.' }))
    }
  })
}

// Watcher sagas
export default function * rootSaga () {
  yield all([
    fork(submitFormRequest)
  ])
}
